<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOWING') }}</label>
              <v-select
                v-model="perPage"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
              cols="12"
              md="5"
              offset-md="1"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('DEBTIA_SEARCH')"
                />
                <b-button
                  variant="primary"
                  @click="searchRecords()"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_SEARCH') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row><br>
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
            </b-col>
            <b-col
              cols="12"
              md="5"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-input-group style="margin-right: 10px">
                  <b-form-input
                    id="example-input"
                    v-model="fromdate"
                    type="text"
                    :placeholder="$t('DEBTIA_FROM')"
                    autocomplete="off"
                    show-decade-nav
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="fromdate"
                      show-decade-nav
                      button-only
                      button-variant="outline-primary"
                      right
                      size="sm"
                      locale="en-US"
                      aria-controls="example-input"
                    />
                  </b-input-group-append>
                </b-input-group>
                <b-input-group style="margin-right: 10px">
                  <b-form-input
                    id="example-input"
                    v-model="tilldate"
                    type="text"
                    :placeholder="$t('DEBTIA_TILL')"
                    autocomplete="off"
                    show-decade-nav
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="tilldate"
                      show-decade-nav
                      button-only
                      button-variant="outline-primary"
                      right
                      size="sm"
                      locale="en-US"
                      aria-controls="example-input"
                    />
                  </b-input-group-append>
                </b-input-group>
              </div>
            </b-col>
            <b-col
              cols="12"
              md="1"
            >
              <div class="d-flex align-items-center justify-content-end">
                <button data-v-aa799a9e="" type="button" class="btn btn-outline-primary" v-on:click="resetDateRange()" style="position: relative;"> Clear </button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          responsive
          ref="roles"
          :fields="logsFields"
          :items="logsData"
        >
          <template #cell(action)="data">
            <feather-icon
              v-b-modal.modal-role
              icon="EyeIcon"
              @click="getLog(data.item)"
            />
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
        <logs-modal
          :log-data="showData"
          :modal-loads="modalLoader"
          :show="!modalLoader"
          :reload-method="getLogs"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BButton, BPagination, BFormDatepicker, BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import LogsModal from './LogsModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormInput,
    BPagination,
    LogsModal,
    BFormDatepicker,
    BInputGroupAppend,
    BInputGroup,
  },
  data() {
    return {
      loader: false,
      logsData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      showData: {},
      modalLoader: true,
      constants,
      fromdate: '',
      tilldate: '',
      user_type: JSON.parse(localStorage.getItem('userData')).data.name,
    }
  },
  computed: {
    logsFields() {
      let fields = []
      fields = [
        { key: 'id', sortable: true },
        { key: 'reference_id', label: i18n.t('DEBTIA_REFERENCE_ID'), thClass: 'column-title' },
        { key: 'event_type', label: i18n.t('DEBTIA_EVENT_TYPE'), thClass: 'column-title' },
        { key: 'filename', label: i18n.t('DEBTIA_FILENAME') },
        { key: 'email', sortable: true, label: i18n.t('DEBTIA_EMAIL') },
        { key: 'created_at', label: i18n.t('DEBTIA_DATE') },
        { key: 'action', label: i18n.t('DEBTIA_ACTION') },
      ]
      return fields
    },
  },
  watch: {
    searchQuery: {
      handler() {
        if (this.searchQuery.length === 0 && this.searchRun) {
          this.searchRun = false
          this.currentPage = 1
          this.getLogs()
        }
      },
    },
    currentPage: {
      handler() {
        this.getLogs()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getLogs()
      },
    },
    fromdate: {
      handler() {
        this.currentPage = 1
        this.getLogs()
      },
    },
    tilldate: {
      handler() {
        this.currentPage = 1
        this.getLogs()
      },
    },
  },
  created() {
    this.getLogs()
  },
  methods: {
    searchRecords() {
      if (this.searchQuery.length > 0) {
        this.searchRun = true
        this.getLogs()
      }
    },
    async getLogs() {
      try {
        this.loader = true
        const url = 'list'
        console.log(this.tilldate)
        const logs = await axios.get(`${constants.baseUrl}/logs-api/${url}?q=${this.searchQuery}&from_date=${this.fromdate}&to_date=${this.tilldate}&perPage=${this.perPage}&page=${this.currentPage}`)
        console.log('logging', logs)

        if (logs.status) {
          this.logsData = logs.data.data.event_logs.data
          this.totalPages = logs.data.data.event_logs.total
          this.from = logs.data.data.event_logs.from
          this.to = logs.data.data.event_logs.to
          this.currentPage = logs.data.data.event_logs.current_page
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    async getLog(item) {
      this.modalLoader = true
      this.showData = item
      this.modalLoader = false
    },
    async resetDateRange() {
      // do some thing
      this.fromdate = ''
      this.tilldate = ''
      await this.getLogs()
      return true
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
th.column-title div {
   width: max-content;
}
</style>
